/** Login, Setup, recuperação de senha e cadastro — PT / EN / ES */
export const authTranslations = {
  pt: {
    'auth.role.generic': 'Colaborador',
    'auth.dev.default_name': 'Desenvolvedor DelivAI',
    'auth.step.code': 'Código',
    'auth.hint.code_whatsapp': 'Digite o código de 6 dígitos enviado ao seu WhatsApp.',
    'auth.hint.code_email': 'Digite o código de 6 dígitos enviado para seu email.',
    'auth.first_access_hint': 'Colaborador sem senha cadastrada. Clique em "Primeiro Acesso - Configurar Senha" para criar sua senha.',
    'auth.error.invalid_cpf': 'CPF inválido. Verifique os números e tente novamente.',
    'auth.error.cpf_not_found_stores': 'CPF não encontrado em nenhuma loja ativa. Verifique com o gestor.',
    'auth.error.cpf_validate_backend': 'Não foi possível validar o CPF. Tente de novo em instantes.',
    'auth.error.invalid_cnpj': 'CNPJ inválido. Verifique os números e tente novamente.',
    'auth.error.login_failed': 'Erro ao fazer login. Tente novamente.',
    'auth.error.wrong_password': 'Senha incorreta. Tente novamente ou recupere sua senha.',
    'auth.error.server_unreachable': 'Não consegui falar com o servidor. Tente de novo.',
    'auth.error.rate_limited': 'Muitas tentativas. Aguarde um pouco e tente de novo.',
    'auth.error.company_name_required': 'Nome da empresa é obrigatório',
    'auth.error.cnpj_digits': 'CNPJ deve ter 14 dígitos',
    'auth.error.email_required': 'Email válido é obrigatório',
    'auth.error.responsible_required': 'Nome do responsável é obrigatório',
    'auth.error.phone_required': 'Telefone é obrigatório',
    'auth.error.niche_required': 'Selecione o nicho da empresa',
    'auth.error.register_process': 'Erro ao processar cadastro. Verifique os dados e tente novamente.',
    'auth.error.register_retry': 'Erro ao processar cadastro. Tente novamente.',
    'auth.error.cpf_not_found': 'CPF não encontrado. Verifique e tente novamente.',
    'auth.error.cnpj_not_found': 'CNPJ não encontrado. Verifique e tente novamente.',
    'auth.error.cnpj_validate': 'Erro ao validar CNPJ. Tente novamente.',
    'auth.error.cnpj_unexpected': 'Não foi possível validar o CNPJ. Tente novamente.',
    'auth.error.first_access_cnpj': 'Cliente encontrado. Clique em Primeiro Acesso para criar sua senha.',
    'auth.error.validate_data': 'Erro ao validar dados. Tente novamente.',
    'auth.error.select_code_channel': 'Selecione WhatsApp ou E-mail para receber o código.',
    'auth.error.enter_code': 'Digite o código de verificação',
    'auth.error.code_wrong': 'Código incorreto. Tente novamente.',
    'auth.error.verify_code_failed': 'Erro ao verificar código. Tente novamente.',
    'auth.error.password_requirements': 'A senha deve atender a todos os requisitos',
    'auth.error.password_mismatch': 'As senhas não coincidem',
    'auth.error.change_password_failed': 'Erro ao alterar senha. Tente novamente.',
    'auth.error.recovery_store_cnpj_required': 'Informe o CNPJ da loja (14 dígitos) para localizar seu cadastro.',
    'auth.error.cpf_not_found_contact_manager': 'CPF não encontrado. Verifique os dados ou fale com o responsável da loja.',
    'auth.error.collaborator_inactive': 'Seu cadastro de colaborador está inativo no momento. Fale com o responsável da loja.',
    'auth.error.store_cnpj_not_resolved': 'Não foi possível identificar o CNPJ da loja para continuar. Fale com o responsável.',
    'auth.error.create_password_failed': 'Erro ao criar senha. Tente novamente.',
    'auth.error.validate_store': 'Erro ao validar loja selecionada.',
    'auth.error.invite_invalid': 'Convite inválido. Peça um novo link ao responsável da loja.',
    'auth.error.accept_terms': 'Aceite os termos para continuar.',
    'auth.error.send_code_failed': 'Erro ao enviar código. Tente novamente.',
    'auth.error.cpf_already_registered': 'Este CPF já possui cadastro. Use o login ou recupere a senha.',
    'auth.error.cpf_in_use_other_store': 'Este CPF já está vinculado a outra loja. Use o login da loja correta.',
    'auth.error.invite_expired': 'O link expirou. Peça um novo convite ao responsável da loja.',
    'auth.error.invite_invalid_link': 'Link expirado ou inválido. Peça um novo convite ao responsável da loja.',
    'auth.error.store_cnpj_unavailable': 'Não foi possível identificar o CNPJ da loja para continuar. Fale com o responsável.',
    'auth.error.cpf_not_found_first_access': 'CPF não encontrado para primeiro acesso. Confira os dados ou fale com o responsável.',
    'auth.error.cpf_existing_team_login': 'Este CPF já possui cadastro. Se você já faz parte da equipe, faça login.',
    'auth.error.invite_expired_whatsapp': 'O link expirou. Peça um novo convite ao responsável da loja pelo WhatsApp.',
    'auth.success.register_thanks': 'Agradecemos seu interesse no DelivAI, em alguns instantes nossa equipe entrará em contato, para finalização do cadastro, fique atento ao email, e não esqueça de verificar a caixa de SPAM',
    'auth.success.code_sent_whatsapp': 'Código enviado por WhatsApp! Verifique suas mensagens.',
    'auth.success.code_sent_email': 'Código enviado para seu email! Verifique sua caixa de entrada.',
    'auth.success.code_verified': 'Código verificado! Agora crie sua nova senha.',
    'auth.success.cpf_validated_choose_channel': 'CPF validado! Escolha como deseja receber o código (WhatsApp ou e-mail).',
    'auth.success.cnpj_validated_confirm_email': 'CNPJ validado! Confirme o email para receber o código de verificação.',
    'auth.success.code_sent_whatsapp_registration': 'Código enviado! Verifique o WhatsApp informado no cadastro.',
    'auth.success.code_sent_email_registration': 'Código enviado! Verifique o e-mail cadastrado (e a caixa de spam).',
    'auth.success.code_sent_email_enter_code': 'Código enviado! Digite o código de verificação enviado para seu email.',
    'auth.success.code_verified_setup': 'Código verificado! Agora crie sua senha.',
    'auth.success.password_changed': 'Senha alterada com sucesso! Redirecionando para o login...',
    'auth.success.password_created': 'Senha criada com sucesso! Redirecionando para o login...',
    'auth.success.cnpj_found': 'CNPJ encontrado! Continue para definir sua senha.',
    'auth.success.cpf_found': 'CPF encontrado! Continue para definir sua senha.',
    'auth.success.invite_confirmed': 'Convite confirmado. Crie sua senha — o link expira em 30 minutos.',
    'auth.success.setup_registration_unlocked': 'Cadastro liberado! Escolha se deseja receber o código por WhatsApp ou e-mail.',
    'auth.success.code_sent_whatsapp_registered': 'Código enviado! Verifique o WhatsApp informado no cadastro.',
    'auth.success.code_sent_email_registered': 'Código enviado! Verifique o e-mail cadastrado (e a caixa de spam).',
    'auth.success.code_sent_enter_email': 'Código enviado! Digite o código de verificação enviado para seu email.',
    'auth.dev.badge_title': 'Painel Interno DelivAI',
    'auth.dev.badge_subtitle': 'Acesso restrito a desenvolvedores e operadores DelivAI.',
    'auth.tab.login': 'Entrar',
    'auth.tab.register': 'Seja Cliente',
    'auth.step_1': 'Etapa 1 de 2',
    'auth.step_2': 'Etapa 2 de 2',
    'auth.collaborator_mode': 'Colaborador da loja',
    'auth.enter_as_store': 'Entrar como loja',
    'auth.choose_store': 'Em qual loja você vai trabalhar?',
    'auth.choose_store_aria': 'Escolha a loja',
    'auth.label.cpf': 'CPF',
    'auth.label.cnpj': 'CNPJ',
    'auth.label.account_key': 'CNPJ, CPF ou e-mail',
    'auth.label.document': 'CNPJ ou CPF',
    'auth.placeholder.account_key': '00.000.000/0000-00, CPF ou e-mail',
    'auth.placeholder.document': 'CNPJ ou CPF',
    'auth.hint.account_key': 'CNPJ da loja, CPF de quem não tem CNPJ, ou e-mail da Dark Kitchen.',
    'auth.error.document': 'Informe um CNPJ ou CPF válido. Se for e-mail, inclua @.',
    'auth.hint.dev_cpf': 'Use o CPF cadastrado no painel interno DelivAI.',
    'auth.validating': 'Validando...',
    'auth.continue': 'Continuar',
    'auth.back_store_login': 'Voltar ao login da loja',
    'auth.dev_role_label': 'Desenvolvedor DelivAI',
    'auth.change_cpf': 'Alterar CPF',
    'auth.change_cnpj': 'Alterar CNPJ',
    'auth.change_email': 'Alterar e-mail',
    'auth.kitchen_group': 'Lojas do grupo',
    'auth.label.kitchen_email': 'E-mail',
    'auth.placeholder.kitchen_email': 'cozinha@loja.com',
    'auth.hint.kitchen_email': 'E-mail do cadastro da loja que virou Dark Kitchen. A senha é a mesma da loja.',
    'auth.kitchen_pick': 'Qual loja abrir?',
    'auth.key_switch': 'Entrar com CNPJ ou e-mail',
    'auth.error.kitchen_email': 'Não encontramos uma Dark Kitchen com esse e-mail.',
    'auth.store_logo_alt': 'Logo da loja',
    'auth.logo_with_name': 'Logo {name}',
    'auth.label.password': 'Senha',
    'auth.label.email': 'Email',
    'auth.loading_login': 'Entrando...',
    'auth.forgot_password': 'Esqueceu sua senha?',
    'auth.register.title': 'Seja nosso Cliente',
    'auth.register.subtitle': 'Preencha os dados abaixo para solicitar seu cadastro',
    'auth.register.success_title': 'Cadastro Realizado com Sucesso!',
    'auth.register.company_name': 'Nome da Empresa *',
    'auth.register.trade_name': 'Nome Fantasia',
    'auth.register.email': 'Email *',
    'auth.register.email_placeholder': 'exemplo@exemplo.com',
    'auth.register.responsible': 'Responsável *',
    'auth.register.responsible_placeholder': 'Nome do responsável',
    'auth.register.phone': 'Telefone *',
    'auth.register.phone_placeholder': '11 9535-2343',
    'auth.register.niche': 'Nicho da Empresa *',
    'auth.register.select_niche': 'Selecione o nicho',
    'auth.register.niche.digital': 'Digital',
    'auth.register.niche.clinic': 'Clínica',
    'auth.register.niche.tattoo': 'Tattoo',
    'auth.register.niche.delivery': 'Delivery',
    'auth.register.niche.workshop': 'Oficina',
    'auth.register.sending': 'Enviando...',
    'auth.register.submit': 'Enviar Cadastro',
    'auth.register.footer': 'Formulário automatizado com DelivAI',
    'auth.onboarding.intro': 'Informe o CNPJ ou CPF, ou envie a foto ou o PDF do cartão CNPJ. A leitura preenche o cadastro de uma vez.',
    'auth.onboarding.photo': 'Enviar foto ou PDF do cartão CNPJ',
    'auth.onboarding.drop': 'Ou solte a foto ou o PDF do cartão aqui',
    'auth.onboarding.drop_now': 'Solte o cartão aqui',
    'auth.onboarding.reading': 'Lendo o cartão…',
    'auth.onboarding.reading_next': 'Em seguida os dados aparecem para você confirmar.',
    'auth.onboarding.confirm': 'Confirmar',
    'auth.onboarding.correct': 'Corrigir',
    'auth.onboarding.already_client': 'Este documento já é cliente. Use Entrar.',
    'auth.onboarding.step_cnpj': 'Confira o documento',
    'auth.onboarding.step_name': 'Razão social e nome fantasia',
    'auth.onboarding.step_contact': 'Contato da empresa',
    'auth.onboarding.company_email': 'E-mail da empresa',
    'auth.onboarding.company_phone': 'Telefone da empresa',
    'auth.onboarding.step_owner': 'Responsável',
    'auth.onboarding.owner_name': 'Nome do responsável',
    'auth.onboarding.owner_cpf': 'CPF do responsável',
    'auth.onboarding.owner_hint': 'Essa pessoa entra como Admin Master da loja, com a senha criada no fim do cadastro.',
    'auth.onboarding.step_address': 'Endereço',
    'auth.onboarding.step_niche': 'Nicho',
    'auth.onboarding.step_about': 'A empresa',
    'auth.onboarding.step_pix': 'Chave PIX',
    'auth.onboarding.step_fees': 'Bairros e taxas',
    'auth.onboarding.step_terms': 'Contrato',
    'auth.onboarding.step_password': 'Senha de acesso',
    'auth.onboarding.trade': 'Nome fantasia',
    'auth.onboarding.legal_name': 'Razão social',
    'auth.onboarding.hours': 'Horário',
    'auth.onboarding.about': 'Sobre a empresa',
    'auth.onboarding.street': 'Rua',
    'auth.onboarding.number': 'Número',
    'auth.onboarding.neighborhood': 'Bairro',
    'auth.onboarding.city': 'Cidade',
    'auth.onboarding.zip': 'CEP',
    'auth.onboarding.state': 'UF',
    'auth.onboarding.pix': 'Chave PIX',
    'auth.onboarding.pix_type': 'Tipo de chave',
    'auth.onboarding.pix_type_placeholder': 'Selecione o tipo',
    'auth.onboarding.pix_skip': 'Seguir sem PIX',
    'auth.onboarding.pix_later': 'Pode deixar em branco e preencher depois, no cadastro da empresa.',
    'auth.onboarding.pix_cpf': 'CPF',
    'auth.onboarding.pix_cnpj': 'CNPJ',
    'auth.onboarding.pix_email': 'E-mail',
    'auth.onboarding.pix_phone': 'Telefone',
    'auth.onboarding.pix_random': 'Chave aleatória',
    'auth.onboarding.fee_place': 'Bairro',
    'auth.onboarding.fee_value': 'Taxa',
    'auth.onboarding.fee_add': 'Adicionar bairro',
    'auth.onboarding.fee_skip': 'Seguir sem taxa',
    'auth.onboarding.terms_doc': 'contrato de licença',
    'auth.onboarding.terms_loading': 'Abrindo o contrato…',
    'auth.onboarding.terms_missing': 'Não consegui abrir o contrato. Tente de novo.',
    'company.menu_read.open': 'Ler foto',
    'company.menu_read.title_menu': 'Ler cardápio',
    'company.menu_read.title_service': 'Ler serviços',
    'company.menu_read.hint': 'Arraste a foto, escolha o arquivo ou cole com Ctrl+V. O + abre outra foto. Unificar junta todas.',
    'company.menu_read.tab': 'Foto {n}',
    'company.menu_read.tab_new': 'Nova aba',
    'company.menu_read.tab_close': 'Fechar aba',
    'company.menu_read.tab_close_title': 'Fechar esta foto?',
    'company.menu_read.tab_close_message': 'Os itens desta foto que ainda não foram para o cardápio serão descartados.',
    'company.menu_read.panel_read': 'Leitura',
    'company.menu_read.panel_catalog': 'Cardápio',
    'company.menu_read.catalog_count': '{count} no cardápio',
    'company.menu_read.dropped_count': '{count} nesta leitura',
    'company.menu_read.drop_here': 'Solte aqui',
    'company.menu_read.select_hint': 'Selecione um ou vários e arraste para a categoria.',
    'company.menu_read.copy_registro': 'Copiar',
    'company.menu_read.copied': 'Copiado',
    'company.menu_read.copy_failed': 'Não consegui copiar o registro.',
    'company.menu_read.drag_handle': 'Arrastar item',
    'company.menu_read.drag_count': '{count} itens',
    'company.menu_read.select_item': 'Selecionar item',
    'company.menu_read.collapse_item': 'Minimizar item',
    'company.menu_read.expand_item': 'Mostrar descrição e preços',
    'company.menu_read.tab_reading': 'Lendo…',
    'company.menu_read.tab_error': 'Falhou',
    'company.menu_read.no_items': 'Nenhum item novo nesta foto.',
    'company.menu_read.empty_catalog': 'Arraste os itens para uma categoria. Se faltar, crie uma nova.',
    'company.menu_read.pending_other': 'Foto {n} ainda tem uma pergunta.',
    'company.menu_read.remove_dropped': 'Tirar da categoria',
    'company.menu_read.destination': 'Categoria',
    'company.menu_read.new_category': 'Ou crie uma categoria nova',
    'company.menu_read.new_category_placeholder': 'Ex.: Lanches - Hot Dog',
    'company.menu_read.change_category': 'Alterar categoria',
    'company.menu_read.pick_category_title': 'Escolher categoria',
    'company.menu_read.pick_category_hint': 'Toque numa categoria já cadastrada ou crie uma nova para este item.',
    'company.menu_read.create_category': 'Usar',
    'company.menu_read.review_subtitle': 'Confira nome, descrição, categoria e preços antes de gravar.',
    'company.menu_read.rename_title': 'Mesmo produto, nome diferente no cadastro',
    'company.menu_read.rename_hint':
      'A foto trouxe o nome do cardápio impresso. No cadastro ainda aparece “base” ou outra variação. Quer atualizar o nome cadastrado?',
    'company.menu_read.rename_from': 'Cadastro',
    'company.menu_read.rename_to': 'Foto',
    'company.menu_read.rename_yes': 'Usar nome da foto',
    'company.menu_read.rename_no': 'Manter cadastro',
    'company.menu_read.add_price': 'Outro preço',
    'company.menu_read.price_name': 'Tipo de preço',
    'company.menu_read.price_new': 'Tipo de preço novo: {names}',
    'company.menu_read.price_same': '{from} entra como {to}.',
    'company.menu_read.as_addon': 'Adicional',
    'company.menu_read.as_product': 'Produto',
    'company.menu_read.as_pizza': 'Pizza',
    'company.menu_read.pick': 'Enviar foto',
    'company.menu_read.another': 'Enviar outra página',
    'company.menu_read.drop': 'Solte a foto aqui',
    'company.menu_read.reading': 'Lendo esta foto…',
    'company.menu_read.saving_menu': 'Atualizando o cardápio…',
    'company.menu_read.saving_service': 'Atualizando os serviços…',
    'company.menu_read.progress': 'Foto {current} de {total}',
    'company.menu_read.confirm': 'Confirmar',
    'company.menu_read.correct': 'Corrigir',
    'company.menu_read.close': 'Fechar',
    'company.menu_read.known': '{count} já estavam no cadastro e não foram repetidos.',
    'company.menu_read.section_known': 'Já no cardápio ({count})',
    'company.menu_read.known_empty': 'Nenhum item desta leitura já estava no cardápio.',
    'company.menu_read.unify': 'Unificar',
    'company.menu_read.history': 'Histórico',
    'company.menu_read.history_empty': 'Nenhuma leitura guardada neste aparelho.',
    'company.menu_read.history_past': 'Leitura já feita nesta loja',
    'company.menu_read.history_pending': 'Pendente',
    'company.menu_read.history_discarded': 'Descartada',
    'company.menu_read.history_updated': 'Atualizada no cardápio',
    'company.menu_read.history_same_badge': 'Já coberta',
    'company.menu_read.history_same': 'Os mesmos itens estão em {code}.',
    'company.menu_read.history_clash': 'Conflita com {code}.',
    'company.menu_read.history_covered': 'Parte já está em {code}.',
    'company.menu_read.history_clash_banner': 'Conflita com {code}. Confirmar fica com o preço desta leitura e tira o item da outra pendente.',
    'company.menu_read.saved_codes': 'Cardápio atualizado. {code}.',
    'company.menu_read.saved_service_codes': 'Serviços atualizados. {code}.',
    'company.menu_read.history_no_prices': 'Esta leitura antiga não guardou os preços da foto. Confira os valores antes de confirmar, ou descarte.',
    'company.menu_read.history_open': 'Abrir',
    'company.menu_read.history_reopen': 'Reabrir',
    'company.menu_read.history_discard': 'Descartar',
    'company.menu_read.history_discard_title': 'Descartar esta leitura?',
    'company.menu_read.history_discard_message': 'Ela fica no histórico como descartada. Dá para reabrir se quiser refazer.',
    'company.menu_read.already_same': 'Já está em {category}. Não crio outro.',
    'company.menu_read.aggregate': 'Agregar descrição',
    'company.menu_read.aggregate_keep': 'Deixar sem descrição',
    'company.menu_read.aggregate_hint': 'Mesmo nome. O cadastro está sem descrição e a foto trouxe uma.',
    'company.menu_read.section_new': 'Vão entrar ({count})',
    'company.menu_read.lands_in': 'Entra em {category}',
    'company.menu_read.locked': 'No teste',
    'company.menu_read.free': 'Liberado',
    'company.menu_read.cap_full': 'No teste dá para deixar 10 produtos liberados. Prenda um para soltar outro.',
    'company.menu_read.failed': 'Não consegui ler esta foto. Tente outra.',
    'company.menu_read.limit': 'Dá para enviar até 8 fotos.',
    'company.menu_read.too_big': 'Um arquivo passou de 4 MB.',
    'company.menu_read.blocked': 'Esse tipo de arquivo não pode ser enviado.',
    'company.menu_read.description': 'Descrição',
    'company.menu_read.duration': 'Minutos',
    'company.menu_read.yes': 'Sim, em todos',
    'company.menu_read.no': 'Não, só em alguns',
    'company.menu_read.trial_line': '{open} liberados nesta leitura. {held} ficam guardados até a contratação.',
    'company.menu_read.trial_catalog': 'No teste, 10 produtos ficam no ar. O restante desta leitura espera a contratação.',
    'company.menu_read.saved': 'Cardápio atualizado.',
    'company.catalog.search_clear': 'Limpar busca',
    'company.catalog.search_more': 'Mostrando 20 de {count}',
    'company.menu_read.registro': 'Registro {code}',
    'company.menu_read.registro_more': '{count} leituras',
    'company.menu_read.discard': 'Descartar este item',
    'auth.onboarding.done_trial': 'Pronto. Você tem 7 dias de teste. Entre com o documento e a senha. Para continuar depois, a licença fica no painel.',
    'auth.onboarding.done_saved': 'Pronto. A senha foi criada. Entre com o documento e a senha.',
    'auth.onboarding.password_again': 'Repita a senha',
    'auth.onboarding.photo_failed': 'Não consegui ler o cartão. Tente outra foto ou digite o documento.',
    'auth.onboarding.password_mismatch': 'As senhas não coincidem.',
    'auth.recovery.title': 'Recuperar Senha',
    'auth.recovery.subtitle': 'Redefina sua senha em poucos passos',
    'auth.recovery.store_cnpj': 'CNPJ da loja',
    'auth.recovery.back_login': 'Voltar ao Login',
    'auth.recovery.how_receive': 'Como deseja receber o código?',
    'auth.recovery.choose_channel_help': 'Escolha o canal. A senha nova vale em todas as lojas deste CPF.',
    'auth.recovery.confirm_email': 'Confirmar e-mail',
    'auth.recovery.email_code_help': 'Enviaremos um código de verificação para o e-mail cadastrado.',
    'auth.recovery.spam_hint': 'Verifique também sua caixa de spam caso não receba o e-mail.',
    'auth.recovery.sending': 'Enviando...',
    'auth.recovery.send_code': 'Enviar código',
    'auth.recovery.send_recovery': 'Enviar Código de Recuperação',
    'auth.recovery.sent_whatsapp': 'Código enviado por: WhatsApp',
    'auth.recovery.sent_to': 'Código enviado para: {destination}',
    'auth.recovery.verifying': 'Verificando...',
    'auth.recovery.verify_code': 'Verificar Código',
    'auth.recovery.new_password': 'Nova Senha',
    'auth.recovery.confirm_password': 'Confirmar Senha',
    'auth.recovery.confirm_new_password': 'Confirmar Nova Senha',
    'auth.recovery.change_password': 'Alterar Senha',
    'auth.recovery.reset_password': 'Redefinir Senha',
    'auth.recovery.changing': 'Alterando...',
    'auth.recovery.your_email': 'seu e-mail',
    'auth.security': 'Segurança',
    'auth.back': 'Voltar',
    'auth.password_requirements': 'Requisitos da senha:',
    'auth.password.min_length': 'Mínimo 6 caracteres',
    'auth.password.uppercase': 'Pelo menos uma letra maiúscula',
    'auth.password.number': 'Pelo menos um número',
    'auth.password.special_char': 'Pelo menos um caractere especial (!@#$%^&*)',
    'auth.password.match': '✓ Senhas coincidem',
    'auth.setup_link_first_access': 'Primeiro Acesso - Configurar Senha 🔑',
    'auth.collaborators': 'Colaboradores',
    'auth.dev_mode_button': 'DelivAI Desenvolvedores',
    'auth.setup.first_access': 'Primeiro Acesso',
    'auth.setup.subtitle_collab': 'Configure sua senha para acessar o painel da loja',
    'auth.setup.subtitle_dev': 'Configure sua senha para acessar o painel interno DelivAI',
    'auth.setup.subtitle_default': 'Configure sua senha',
    'auth.setup.brand_logo_alt': 'Logo DelivAI',
    'auth.setup.validating_invite': 'Validando convite…',
    'auth.setup.invite_invalid_title': 'Link expirado ou inválido',
    'auth.setup.invite_invalid_hint': 'Peça ao responsável da loja um novo convite por WhatsApp.',
    'auth.setup.go_login': 'Ir para o login',
    'auth.setup.enter_cpf': 'Digite seu CPF',
    'auth.setup.enter_cnpj': 'Digite seu CNPJ',
    'auth.setup.choose_channel': 'Como deseja receber o código?',
    'auth.setup.confirm_email': 'Confirmar Email',
    'auth.setup.channel_hint': 'Escolha o canal para receber o código de verificação',
    'auth.setup.channel.whatsapp': 'WhatsApp',
    'auth.setup.channel.email': 'E-mail',
    'auth.setup.email_masked': 'Email: {email}',
    'auth.setup.code_will_send': 'Enviaremos um código de 6 dígitos para confirmar sua identidade.',
    'auth.setup.code_will_send_email': 'Enviaremos um código de verificação para o email acima.',
    'auth.setup.spam_hint': 'Se escolher e-mail, verifique também a caixa de spam.',
    'auth.setup.spam_hint_email': '💡 Dica: Verifique também sua caixa de spam caso não receba o email.',
    'auth.setup.verification_code': 'Código de Verificação',
    'auth.setup.create_password': 'Crie sua senha',
    'auth.setup.create_password_btn': 'Criar Senha',
    'auth.setup.confirm_password_label': 'Confirmar Senha *',
    'auth.setup.checking_cpf': 'Verificando CPF…',
    'auth.setup.cpf_hint_invite': 'Informe seu CPF para vincular ao convite.',
    'auth.setup.cpf_hint_complete_signup': 'Informe seu CPF para concluir o cadastro e criar a senha.',
    'auth.setup.cpf_invalid_invite': 'CPF inválido ou não corresponde ao convite.',
    'auth.setup.your_email': 'seu email',
    'auth.setup.passwords_match': '✓ Senhas coincidem',
    'auth.setup.creating_password': 'Criando...',
    'auth.setup.already_have_account': 'Já tem uma conta? Faça login',
    'auth.setup.terms_of_use': 'termos de uso',
    'auth.setup.terms_accept_prefix': 'Li e aceito os',
    'auth.setup.terms_version': '(versão {version}).',
    'auth.setup.terms_loading': 'Carregando {title}…',
    'auth.setup.terms_load_error': 'Não foi possível carregar os termos.',
    'auth.setup.terms_modal_close': 'Fechar',
    'auth.setup.progress.store': 'Loja',
    'auth.setup.progress.cpf': 'CPF',
    'auth.setup.progress.send': 'Envio',
    'auth.setup.progress.code': 'Código',
    'auth.setup.progress.password': 'Senha',
    'auth.setup.progress.cnpj': 'CNPJ',
    'auth.setup.progress.email': 'Email',
    'auth.setup.step.confirm_email': 'Confirmar e-mail',
  },
  en: {
    'auth.role.generic': 'Employee',
    'auth.dev.default_name': 'DelivAI Developer',
    'auth.step.code': 'Code',
    'auth.hint.code_whatsapp': 'Enter the 6-digit code sent to your WhatsApp.',
    'auth.hint.code_email': 'Enter the 6-digit code sent to your email.',
    'auth.first_access_hint': 'No password set yet. Click "First access - Set password" to create your password.',
    'auth.error.invalid_cpf': 'Invalid CPF. Check the numbers and try again.',
    'auth.error.cpf_not_found_stores': 'CPF not found in any active store. Check with your manager.',
    'auth.error.cpf_validate_backend': 'Could not validate CPF. Please try again shortly.',
    'auth.error.invalid_cnpj': 'Invalid CNPJ. Check the numbers and try again.',
    'auth.error.login_failed': 'Login failed. Please try again.',
    'auth.error.wrong_password': 'Incorrect password. Try again or recover your password.',
    'auth.error.server_unreachable': 'Could not reach the server. Try again.',
    'auth.error.rate_limited': 'Too many attempts. Wait a moment and try again.',
    'auth.error.company_name_required': 'Company name is required',
    'auth.error.cnpj_digits': 'CNPJ must have 14 digits',
    'auth.error.email_required': 'Valid email is required',
    'auth.error.responsible_required': 'Responsible person name is required',
    'auth.error.phone_required': 'Phone is required',
    'auth.error.niche_required': 'Select the business niche',
    'auth.error.register_process': 'Error processing registration. Check your data and try again.',
    'auth.error.register_retry': 'Error processing registration. Please try again.',
    'auth.error.cpf_not_found': 'CPF not found. Check and try again.',
    'auth.error.cnpj_not_found': 'CNPJ not found. Check and try again.',
    'auth.error.cnpj_validate': 'Error validating CNPJ. Please try again.',
    'auth.error.cnpj_unexpected': 'Could not validate the CNPJ. Please try again.',
    'auth.error.first_access_cnpj': 'Company found. Click First access to create your password.',
    'auth.error.validate_data': 'Error validating data. Please try again.',
    'auth.error.select_code_channel': 'Select WhatsApp or Email to receive the code.',
    'auth.error.enter_code': 'Enter the verification code',
    'auth.error.code_wrong': 'Incorrect code. Try again.',
    'auth.error.verify_code_failed': 'Error verifying code. Please try again.',
    'auth.error.password_requirements': 'Password must meet all requirements',
    'auth.error.password_mismatch': 'Passwords do not match',
    'auth.error.change_password_failed': 'Error changing password. Please try again.',
    'auth.error.recovery_store_cnpj_required': 'Enter the store CNPJ (14 digits) to find your account.',
    'auth.error.cpf_not_found_contact_manager': 'CPF not found. Check your data or contact the store manager.',
    'auth.error.collaborator_inactive': 'Your employee account is currently inactive. Contact the store manager.',
    'auth.error.store_cnpj_not_resolved': 'Could not identify the store CNPJ to continue. Contact the manager.',
    'auth.error.create_password_failed': 'Error creating password. Please try again.',
    'auth.error.validate_store': 'Error validating selected store.',
    'auth.error.invite_invalid': 'Invalid invite. Ask the store manager for a new link.',
    'auth.error.accept_terms': 'Accept the terms to continue.',
    'auth.error.send_code_failed': 'Error sending code. Please try again.',
    'auth.error.cpf_already_registered': 'This CPF is already registered. Use login or recover your password.',
    'auth.error.cpf_in_use_other_store': 'This CPF is already linked to another store. Use the correct store login.',
    'auth.error.invite_expired': 'The link expired. Ask the store manager for a new invite.',
    'auth.error.invite_invalid_link': 'Expired or invalid link. Ask the store manager for a new invite.',
    'auth.error.store_cnpj_unavailable': 'Could not identify the store CNPJ to continue. Contact the manager.',
    'auth.error.cpf_not_found_first_access': 'CPF not found for first access. Check your data or contact the manager.',
    'auth.error.cpf_existing_team_login': 'This CPF is already registered. If you are already on the team, log in.',
    'auth.error.invite_expired_whatsapp': 'The link expired. Ask the store manager for a new WhatsApp invite.',
    'auth.success.register_thanks': 'Thank you for your interest in DelivAI. Our team will contact you shortly to complete registration. Check your email, including spam.',
    'auth.success.code_sent_whatsapp': 'Code sent via WhatsApp! Check your messages.',
    'auth.success.code_sent_email': 'Code sent to your email! Check your inbox.',
    'auth.success.code_verified': 'Code verified! Now create your new password.',
    'auth.success.cpf_validated_choose_channel': 'CPF validated! Choose how you want to receive the code (WhatsApp or email).',
    'auth.success.cnpj_validated_confirm_email': 'CNPJ validated! Confirm the email to receive the verification code.',
    'auth.success.code_sent_whatsapp_registration': 'Code sent! Check the WhatsApp registered on your account.',
    'auth.success.code_sent_email_registration': 'Code sent! Check the registered email (and spam folder).',
    'auth.success.code_sent_email_enter_code': 'Code sent! Enter the verification code sent to your email.',
    'auth.success.code_verified_setup': 'Code verified! Now create your password.',
    'auth.success.password_changed': 'Password changed successfully! Redirecting to login...',
    'auth.success.password_created': 'Password created successfully! Redirecting to login...',
    'auth.success.cnpj_found': 'CNPJ found! Continue to set your password.',
    'auth.success.cpf_found': 'CPF found! Continue to set your password.',
    'auth.success.invite_confirmed': 'Invite confirmed. Create your password — the link expires in 30 minutes.',
    'auth.success.setup_registration_unlocked': 'Registration unlocked! Choose whether to receive the code via WhatsApp or email.',
    'auth.success.code_sent_whatsapp_registered': 'Code sent! Check the WhatsApp registered on your account.',
    'auth.success.code_sent_email_registered': 'Code sent! Check your registered email (and spam folder).',
    'auth.success.code_sent_enter_email': 'Code sent! Enter the verification code sent to your email.',
    'auth.dev.badge_title': 'DelivAI Internal Panel',
    'auth.dev.badge_subtitle': 'Restricted access for DelivAI developers and operators.',
    'auth.tab.login': 'Sign in',
    'auth.tab.register': 'Become a client',
    'auth.step_1': 'Step 1 of 2',
    'auth.step_2': 'Step 2 of 2',
    'auth.collaborator_mode': 'Store employee',
    'auth.enter_as_store': 'Sign in as store',
    'auth.choose_store': 'Which store will you work at?',
    'auth.choose_store_aria': 'Choose store',
    'auth.label.cpf': 'CPF',
    'auth.label.cnpj': 'CNPJ',
    'auth.label.account_key': 'Tax ID, CPF or email',
    'auth.label.document': 'Tax ID or CPF',
    'auth.placeholder.account_key': 'Tax ID, CPF or email',
    'auth.placeholder.document': 'Tax ID or CPF',
    'auth.hint.account_key': 'Store tax ID, personal CPF if there is no company ID, or the Dark Kitchen email.',
    'auth.error.document': 'Enter a valid tax ID or CPF. For email, include @.',
    'auth.hint.dev_cpf': 'Use the CPF registered in the DelivAI internal panel.',
    'auth.validating': 'Validating...',
    'auth.continue': 'Continue',
    'auth.back_store_login': 'Back to store login',
    'auth.dev_role_label': 'DelivAI Developer',
    'auth.change_cpf': 'Change CPF',
    'auth.change_cnpj': 'Change CNPJ',
    'auth.change_email': 'Change email',
    'auth.kitchen_group': 'Stores in the group',
    'auth.label.kitchen_email': 'Email',
    'auth.placeholder.kitchen_email': 'kitchen@store.com',
    'auth.hint.kitchen_email': 'Email on the store that became a Dark Kitchen. The password is the store password.',
    'auth.kitchen_pick': 'Which store should open?',
    'auth.key_switch': 'Sign in with tax ID or email',
    'auth.error.kitchen_email': 'No Dark Kitchen was found for this email.',
    'auth.store_logo_alt': 'Store logo',
    'auth.logo_with_name': 'Logo {name}',
    'auth.label.password': 'Password',
    'auth.label.email': 'Email',
    'auth.loading_login': 'Signing in...',
    'auth.forgot_password': 'Forgot your password?',
    'auth.register.title': 'Become our client',
    'auth.register.subtitle': 'Fill in the details below to request registration',
    'auth.register.success_title': 'Registration submitted successfully!',
    'auth.register.company_name': 'Company name *',
    'auth.register.trade_name': 'Trade name',
    'auth.register.email': 'Email *',
    'auth.register.email_placeholder': 'example@example.com',
    'auth.register.responsible': 'Responsible *',
    'auth.register.responsible_placeholder': 'Responsible person name',
    'auth.register.phone': 'Phone *',
    'auth.register.phone_placeholder': '11 9535-2343',
    'auth.register.niche': 'Business niche *',
    'auth.register.select_niche': 'Select niche',
    'auth.register.niche.digital': 'Digital',
    'auth.register.niche.clinic': 'Clinic',
    'auth.register.niche.tattoo': 'Tattoo',
    'auth.register.niche.delivery': 'Delivery',
    'auth.register.niche.workshop': 'Workshop',
    'auth.register.sending': 'Sending...',
    'auth.register.submit': 'Submit registration',
    'auth.register.footer': 'Automated form powered by DelivAI',
    'auth.onboarding.intro': 'Enter the CNPJ or CPF, or send a photo or PDF of the CNPJ card. One reading fills the registration.',
    'auth.onboarding.photo': 'Send a photo or PDF of the CNPJ card',
    'auth.onboarding.drop': 'Or drop the card photo or PDF here',
    'auth.onboarding.drop_now': 'Drop the card here',
    'auth.onboarding.reading': 'Reading the card…',
    'auth.onboarding.reading_next': 'Next, the details show up for you to confirm.',
    'auth.onboarding.confirm': 'Confirm',
    'auth.onboarding.correct': 'Edit',
    'auth.onboarding.already_client': 'This document is already a client. Use Sign in.',
    'auth.onboarding.step_cnpj': 'Check the document',
    'auth.onboarding.step_name': 'Legal name and trade name',
    'auth.onboarding.step_contact': 'Company contact',
    'auth.onboarding.company_email': 'Company email',
    'auth.onboarding.company_phone': 'Company phone',
    'auth.onboarding.step_owner': 'Responsible person',
    'auth.onboarding.owner_name': 'Responsible person name',
    'auth.onboarding.owner_cpf': 'Responsible person CPF',
    'auth.onboarding.owner_hint': 'This person becomes the store Admin Master, using the password created at the end.',
    'auth.onboarding.step_address': 'Address',
    'auth.onboarding.step_niche': 'Niche',
    'auth.onboarding.step_about': 'The business',
    'auth.onboarding.step_pix': 'PIX key',
    'auth.onboarding.step_fees': 'Neighborhoods and fees',
    'auth.onboarding.step_terms': 'Contract',
    'auth.onboarding.step_password': 'Access password',
    'auth.onboarding.trade': 'Trade name',
    'auth.onboarding.legal_name': 'Legal name',
    'auth.onboarding.hours': 'Hours',
    'auth.onboarding.about': 'About the business',
    'auth.onboarding.street': 'Street',
    'auth.onboarding.number': 'Number',
    'auth.onboarding.neighborhood': 'Neighborhood',
    'auth.onboarding.city': 'City',
    'auth.onboarding.zip': 'ZIP',
    'auth.onboarding.state': 'State',
    'auth.onboarding.pix': 'PIX key',
    'auth.onboarding.pix_type': 'Key type',
    'auth.onboarding.pix_type_placeholder': 'Select the type',
    'auth.onboarding.pix_skip': 'Continue without PIX',
    'auth.onboarding.pix_later': 'You can leave this blank and fill it in later, in the company profile.',
    'auth.onboarding.pix_cpf': 'CPF',
    'auth.onboarding.pix_cnpj': 'CNPJ',
    'auth.onboarding.pix_email': 'Email',
    'auth.onboarding.pix_phone': 'Phone',
    'auth.onboarding.pix_random': 'Random key',
    'auth.onboarding.fee_place': 'Neighborhood',
    'auth.onboarding.fee_value': 'Fee',
    'auth.onboarding.fee_add': 'Add neighborhood',
    'auth.onboarding.fee_skip': 'Continue without fees',
    'auth.onboarding.terms_doc': 'license contract',
    'auth.onboarding.terms_loading': 'Opening the contract…',
    'auth.onboarding.terms_missing': 'Could not open the contract. Try again.',
    'company.menu_read.open': 'Read photo',
    'company.menu_read.title_menu': 'Read menu',
    'company.menu_read.title_service': 'Read services',
    'company.menu_read.hint': 'Drop the photo, choose a file, or paste with Ctrl+V. + opens another photo. Combine merges them all.',
    'company.menu_read.tab': 'Photo {n}',
    'company.menu_read.tab_new': 'New tab',
    'company.menu_read.tab_close': 'Close tab',
    'company.menu_read.tab_close_title': 'Close this photo?',
    'company.menu_read.tab_close_message': 'Items from this photo that are not in the menu yet will be discarded.',
    'company.menu_read.panel_read': 'Reading',
    'company.menu_read.panel_catalog': 'Menu',
    'company.menu_read.catalog_count': '{count} in the menu',
    'company.menu_read.dropped_count': '{count} in this reading',
    'company.menu_read.drop_here': 'Drop here',
    'company.menu_read.select_hint': 'Select one or more and drag them to a category.',
    'company.menu_read.copy_registro': 'Copy',
    'company.menu_read.copied': 'Copied',
    'company.menu_read.copy_failed': 'Could not copy the record id.',
    'company.menu_read.drag_handle': 'Drag item',
    'company.menu_read.drag_count': '{count} items',
    'company.menu_read.select_item': 'Select item',
    'company.menu_read.collapse_item': 'Collapse item',
    'company.menu_read.expand_item': 'Show description and prices',
    'company.menu_read.tab_reading': 'Reading…',
    'company.menu_read.tab_error': 'Failed',
    'company.menu_read.no_items': 'No new items in this photo.',
    'company.menu_read.empty_catalog': 'Drag items onto a category. Create one if you need it.',
    'company.menu_read.pending_other': 'Photo {n} still has a question.',
    'company.menu_read.remove_dropped': 'Remove from category',
    'company.menu_read.destination': 'Category',
    'company.menu_read.new_category': 'Or create a new category',
    'company.menu_read.new_category_placeholder': 'E.g. Sandwiches - Hot Dog',
    'company.menu_read.change_category': 'Change category',
    'company.menu_read.pick_category_title': 'Choose category',
    'company.menu_read.pick_category_hint': 'Tap an existing category or create a new one for this item.',
    'company.menu_read.create_category': 'Use',
    'company.menu_read.review_subtitle': 'Check name, description, category and prices before saving.',
    'company.menu_read.rename_title': 'Same product, different name in the catalog',
    'company.menu_read.rename_hint':
      'The photo used the printed menu name. The catalog still has “base” or another variation. Update the saved name?',
    'company.menu_read.rename_from': 'Catalog',
    'company.menu_read.rename_to': 'Photo',
    'company.menu_read.rename_yes': 'Use photo name',
    'company.menu_read.rename_no': 'Keep catalog name',
    'company.menu_read.add_price': 'Another price',
    'company.menu_read.price_name': 'Price type',
    'company.menu_read.price_new': 'New price type: {names}',
    'company.menu_read.price_same': '{from} goes in as {to}.',
    'company.menu_read.as_addon': 'Add-on',
    'company.menu_read.as_product': 'Product',
    'company.menu_read.as_pizza': 'Pizza',
    'company.menu_read.pick': 'Send photo',
    'company.menu_read.another': 'Send another page',
    'company.menu_read.drop': 'Drop the photo here',
    'company.menu_read.reading': 'Reading this photo…',
    'company.menu_read.saving_menu': 'Updating the menu…',
    'company.menu_read.saving_service': 'Updating the services…',
    'company.menu_read.progress': 'Photo {current} of {total}',
    'company.menu_read.confirm': 'Confirm',
    'company.menu_read.correct': 'Correct',
    'company.menu_read.close': 'Close',
    'company.menu_read.known': '{count} were already saved and were not repeated.',
    'company.menu_read.section_known': 'Already on the menu ({count})',
    'company.menu_read.known_empty': 'Nothing in this reading was already on the menu.',
    'company.menu_read.unify': 'Combine',
    'company.menu_read.history': 'History',
    'company.menu_read.history_empty': 'No readings saved on this device.',
    'company.menu_read.history_past': 'Reading already done for this store',
    'company.menu_read.history_pending': 'Pending',
    'company.menu_read.history_discarded': 'Discarded',
    'company.menu_read.history_updated': 'Updated on the menu',
    'company.menu_read.history_same_badge': 'Already covered',
    'company.menu_read.history_same': 'The same items are in {code}.',
    'company.menu_read.history_clash': 'Conflicts with {code}.',
    'company.menu_read.history_covered': 'Part of it is already in {code}.',
    'company.menu_read.history_clash_banner': 'Conflicts with {code}. Confirming keeps this reading’s price and removes the item from the other pending one.',
    'company.menu_read.saved_codes': 'Menu updated. {code}.',
    'company.menu_read.saved_service_codes': 'Services updated. {code}.',
    'company.menu_read.history_no_prices': 'This older reading did not keep the photo prices. Check the amounts before confirming, or discard it.',
    'company.menu_read.history_open': 'Open',
    'company.menu_read.history_reopen': 'Reopen',
    'company.menu_read.history_discard': 'Discard',
    'company.menu_read.history_discard_title': 'Discard this reading?',
    'company.menu_read.history_discard_message': 'It stays in the history as discarded. You can reopen it if you want to do it again.',
    'company.menu_read.already_same': 'Already in {category}. It will not be created again.',
    'company.menu_read.aggregate': 'Add description',
    'company.menu_read.aggregate_keep': 'Leave it blank',
    'company.menu_read.aggregate_hint': 'Same name. The saved item has no description and the photo has one.',
    'company.menu_read.section_new': 'Will be added ({count})',
    'company.menu_read.lands_in': 'Goes into {category}',
    'company.menu_read.locked': 'On trial',
    'company.menu_read.free': 'Available',
    'company.menu_read.cap_full': 'On the trial you can keep 10 products available. Hold one to release another.',
    'company.menu_read.failed': 'Could not read this photo. Try another.',
    'company.menu_read.limit': 'You can send up to 8 photos.',
    'company.menu_read.too_big': 'A file is over 4 MB.',
    'company.menu_read.blocked': 'This file type cannot be sent.',
    'company.menu_read.description': 'Description',
    'company.menu_read.duration': 'Minutes',
    'company.menu_read.yes': 'Yes, all of them',
    'company.menu_read.no': 'No, only some',
    'company.menu_read.trial_line': '{open} available from this reading. {held} stay stored until you subscribe.',
    'company.menu_read.trial_catalog': 'On the trial, 10 products stay live. The rest of this reading waits for a subscription.',
    'company.menu_read.saved': 'Menu updated.',
    'company.catalog.search_clear': 'Clear search',
    'company.catalog.search_more': 'Showing 20 of {count}',
    'company.menu_read.registro': 'Record {code}',
    'company.menu_read.registro_more': '{count} reads',
    'company.menu_read.discard': 'Discard this item',
    'auth.onboarding.done_trial': 'Done. You have 7 trial days. Sign in with the document and password. To continue later, the license is in the panel.',
    'auth.onboarding.done_saved': 'Done. The password was created. Sign in with the document and password.',
    'auth.onboarding.password_again': 'Repeat the password',
    'auth.onboarding.photo_failed': 'Could not read the card. Try another photo or type the document.',
    'auth.onboarding.password_mismatch': 'Passwords do not match.',
    'auth.recovery.title': 'Recover password',
    'auth.recovery.subtitle': 'Reset your password in a few steps',
    'auth.recovery.store_cnpj': 'Store CNPJ',
    'auth.recovery.back_login': 'Back to login',
    'auth.recovery.how_receive': 'How do you want to receive the code?',
    'auth.recovery.choose_channel_help': 'Choose the channel. The new password works at every store linked to this CPF.',
    'auth.recovery.confirm_email': 'Confirm email',
    'auth.recovery.email_code_help': 'We will send a verification code to the registered email.',
    'auth.recovery.spam_hint': 'Also check your spam folder if you do not receive the email.',
    'auth.recovery.sending': 'Sending...',
    'auth.recovery.send_code': 'Send code',
    'auth.recovery.send_recovery': 'Send recovery code',
    'auth.recovery.sent_whatsapp': 'Code sent via: WhatsApp',
    'auth.recovery.sent_to': 'Code sent to: {destination}',
    'auth.recovery.verifying': 'Verifying...',
    'auth.recovery.verify_code': 'Verify code',
    'auth.recovery.new_password': 'New password',
    'auth.recovery.confirm_password': 'Confirm password',
    'auth.recovery.confirm_new_password': 'Confirm new password',
    'auth.recovery.change_password': 'Change password',
    'auth.recovery.reset_password': 'Reset password',
    'auth.recovery.changing': 'Changing...',
    'auth.recovery.your_email': 'your email',
    'auth.security': 'Security',
    'auth.back': 'Back',
    'auth.password_requirements': 'Password requirements:',
    'auth.password.min_length': 'Minimum 6 characters',
    'auth.password.uppercase': 'At least one uppercase letter',
    'auth.password.number': 'At least one number',
    'auth.password.special_char': 'At least one special character (!@#$%^&*)',
    'auth.password.match': '✓ Passwords match',
    'auth.setup_link_first_access': 'First access - Set password 🔑',
    'auth.collaborators': 'Collaborators',
    'auth.dev_mode_button': 'DelivAI Developers',
    'auth.setup.first_access': 'First access',
    'auth.setup.subtitle_collab': 'Set your password to access the store dashboard',
    'auth.setup.subtitle_dev': 'Set your password to access the DelivAI internal panel',
    'auth.setup.subtitle_default': 'Set your password',
    'auth.setup.brand_logo_alt': 'DelivAI logo',
    'auth.setup.validating_invite': 'Validating invite…',
    'auth.setup.invite_invalid_title': 'Expired or invalid link',
    'auth.setup.invite_invalid_hint': 'Ask the store manager for a new WhatsApp invite.',
    'auth.setup.go_login': 'Go to login',
    'auth.setup.enter_cpf': 'Enter your CPF',
    'auth.setup.enter_cnpj': 'Enter your CNPJ',
    'auth.setup.choose_channel': 'How do you want to receive the code?',
    'auth.setup.confirm_email': 'Confirm email',
    'auth.setup.channel_hint': 'Choose the channel to receive the verification code',
    'auth.setup.channel.whatsapp': 'WhatsApp',
    'auth.setup.channel.email': 'Email',
    'auth.setup.email_masked': 'Email: {email}',
    'auth.setup.code_will_send': 'We will send a 6-digit code to confirm your identity.',
    'auth.setup.code_will_send_email': 'We will send a verification code to the email above.',
    'auth.setup.spam_hint': 'If you choose email, also check your spam folder.',
    'auth.setup.spam_hint_email': '💡 Tip: Also check your spam folder if you do not receive the email.',
    'auth.setup.verification_code': 'Verification code',
    'auth.setup.create_password': 'Create your password',
    'auth.setup.create_password_btn': 'Create password',
    'auth.setup.confirm_password_label': 'Confirm password *',
    'auth.setup.checking_cpf': 'Checking CPF…',
    'auth.setup.cpf_hint_invite': 'Enter your CPF to link to the invite.',
    'auth.setup.cpf_hint_complete_signup': 'Enter your CPF to complete registration and create your password.',
    'auth.setup.cpf_invalid_invite': 'Invalid CPF or does not match the invite.',
    'auth.setup.your_email': 'your email',
    'auth.setup.passwords_match': '✓ Passwords match',
    'auth.setup.creating_password': 'Creating...',
    'auth.setup.already_have_account': 'Already have an account? Log in',
    'auth.setup.terms_of_use': 'terms of use',
    'auth.setup.terms_accept_prefix': 'I have read and accept the',
    'auth.setup.terms_version': '(version {version}).',
    'auth.setup.terms_loading': 'Loading {title}…',
    'auth.setup.terms_load_error': 'Could not load the terms.',
    'auth.setup.terms_modal_close': 'Close',
    'auth.setup.progress.store': 'Store',
    'auth.setup.progress.cpf': 'CPF',
    'auth.setup.progress.send': 'Send',
    'auth.setup.progress.code': 'Code',
    'auth.setup.progress.password': 'Password',
    'auth.setup.progress.cnpj': 'CNPJ',
    'auth.setup.progress.email': 'Email',
    'auth.setup.step.confirm_email': 'Confirm email',
  },
  es: {
    'auth.role.generic': 'Colaborador',
    'auth.dev.default_name': 'Desarrollador DelivAI',
    'auth.step.code': 'Código',
    'auth.hint.code_whatsapp': 'Ingrese el código de 6 dígitos enviado a su WhatsApp.',
    'auth.hint.code_email': 'Ingrese el código de 6 dígitos enviado a su email.',
    'auth.first_access_hint': 'Sin contraseña registrada. Haga clic en "Primer acceso - Configurar contraseña" para crear su contraseña.',
    'auth.error.invalid_cpf': 'CPF inválido. Verifique los números e intente de nuevo.',
    'auth.error.cpf_not_found_stores': 'CPF no encontrado en ninguna tienda activa. Consulte con su gerente.',
    'auth.error.cpf_validate_backend': 'No se pudo validar el CPF. Intente de nuevo en unos momentos.',
    'auth.error.invalid_cnpj': 'CNPJ inválido. Verifique los números e intente de nuevo.',
    'auth.error.login_failed': 'Error al iniciar sesión. Intente de nuevo.',
    'auth.error.wrong_password': 'Contraseña incorrecta. Intente de nuevo o recupere su contraseña.',
    'auth.error.server_unreachable': 'No pude hablar con el servidor. Intente de nuevo.',
    'auth.error.rate_limited': 'Demasiados intentos. Espere un momento e intente de nuevo.',
    'auth.error.company_name_required': 'El nombre de la empresa es obligatorio',
    'auth.error.cnpj_digits': 'El CNPJ debe tener 14 dígitos',
    'auth.error.email_required': 'Se requiere un email válido',
    'auth.error.responsible_required': 'El nombre del responsable es obligatorio',
    'auth.error.phone_required': 'El teléfono es obligatorio',
    'auth.error.niche_required': 'Seleccione el nicho de la empresa',
    'auth.error.register_process': 'Error al procesar el registro. Verifique los datos e intente de nuevo.',
    'auth.error.register_retry': 'Error al procesar el registro. Intente de nuevo.',
    'auth.error.cpf_not_found': 'CPF no encontrado. Verifique e intente de nuevo.',
    'auth.error.cnpj_not_found': 'CNPJ no encontrado. Verifique e intente de nuevo.',
    'auth.error.cnpj_validate': 'Error al validar CNPJ. Intente de nuevo.',
    'auth.error.cnpj_unexpected': 'No se pudo validar el CNPJ. Intente de nuevo.',
    'auth.error.first_access_cnpj': 'Cliente encontrado. Haga clic en Primer acceso para crear su contraseña.',
    'auth.error.validate_data': 'Error al validar datos. Intente de nuevo.',
    'auth.error.select_code_channel': 'Seleccione WhatsApp o Email para recibir el código.',
    'auth.error.enter_code': 'Ingrese el código de verificación',
    'auth.error.code_wrong': 'Código incorrecto. Intente de nuevo.',
    'auth.error.verify_code_failed': 'Error al verificar código. Intente de nuevo.',
    'auth.error.password_requirements': 'La contraseña debe cumplir todos los requisitos',
    'auth.error.password_mismatch': 'Las contraseñas no coinciden',
    'auth.error.change_password_failed': 'Error al cambiar contraseña. Intente de nuevo.',
    'auth.error.recovery_store_cnpj_required': 'Informe el CNPJ de la tienda (14 dígitos) para localizar su registro.',
    'auth.error.cpf_not_found_contact_manager': 'CPF no encontrado. Verifique los datos o consulte al responsable de la tienda.',
    'auth.error.collaborator_inactive': 'Su registro de colaborador está inactivo en este momento. Consulte al responsable de la tienda.',
    'auth.error.store_cnpj_not_resolved': 'No fue posible identificar el CNPJ de la tienda para continuar. Consulte al responsable.',
    'auth.error.create_password_failed': 'Error al crear contraseña. Intente de nuevo.',
    'auth.error.validate_store': 'Error al validar la tienda seleccionada.',
    'auth.error.invite_invalid': 'Invitación inválida. Pida un nuevo enlace al responsable de la tienda.',
    'auth.error.accept_terms': 'Acepte los términos para continuar.',
    'auth.error.send_code_failed': 'Error al enviar código. Intente de nuevo.',
    'auth.error.cpf_already_registered': 'Este CPF ya está registrado. Use el login o recupere la contraseña.',
    'auth.error.cpf_in_use_other_store': 'Este CPF ya está vinculado a otra tienda. Use el login de la tienda correcta.',
    'auth.error.invite_expired': 'El enlace expiró. Pida una nueva invitación al responsable.',
    'auth.error.invite_invalid_link': 'Enlace expirado o inválido. Pida una nueva invitación al responsable.',
    'auth.error.store_cnpj_unavailable': 'No fue posible identificar el CNPJ de la tienda para continuar. Hable con el responsable.',
    'auth.error.cpf_not_found_first_access': 'CPF no encontrado para primer acceso. Verifique los datos o hable con el responsable.',
    'auth.error.cpf_existing_team_login': 'Este CPF ya tiene registro. Si ya forma parte del equipo, inicie sesión.',
    'auth.error.invite_expired_whatsapp': 'El enlace expiró. Pida una nueva invitación al responsable de la tienda por WhatsApp.',
    'auth.success.register_thanks': 'Gracias por su interés en DelivAI. Nuestro equipo se pondrá en contacto pronto. Revise su email, incluido spam.',
    'auth.success.code_sent_whatsapp': '¡Código enviado por WhatsApp! Revise sus mensajes.',
    'auth.success.code_sent_email': '¡Código enviado a su email! Revise su bandeja de entrada.',
    'auth.success.code_verified': '¡Código verificado! Ahora cree su nueva contraseña.',
    'auth.success.cpf_validated_choose_channel': '¡CPF validado! Elija cómo desea recibir el código (WhatsApp o email).',
    'auth.success.cnpj_validated_confirm_email': '¡CNPJ validado! Confirme el email para recibir el código de verificación.',
    'auth.success.code_sent_whatsapp_registration': '¡Código enviado! Verifique el WhatsApp registrado en su cuenta.',
    'auth.success.code_sent_email_registration': '¡Código enviado! Verifique el email registrado (y la carpeta de spam).',
    'auth.success.code_sent_email_enter_code': '¡Código enviado! Ingrese el código de verificación enviado a su email.',
    'auth.success.code_verified_setup': '¡Código verificado! Ahora cree su contraseña.',
    'auth.success.password_changed': '¡Contraseña cambiada con éxito! Redirigiendo al login...',
    'auth.success.password_created': '¡Contraseña creada con éxito! Redirigiendo al login...',
    'auth.success.cnpj_found': '¡CNPJ encontrado! Continúe para definir su contraseña.',
    'auth.success.cpf_found': '¡CPF encontrado! Continúe para definir su contraseña.',
    'auth.success.invite_confirmed': 'Invitación confirmada. Cree su contraseña — el enlace expira en 30 minutos.',
    'auth.success.setup_registration_unlocked': '¡Registro liberado! Elija si desea recibir el código por WhatsApp o email.',
    'auth.success.code_sent_whatsapp_registered': '¡Código enviado! Revise el WhatsApp informado en el registro.',
    'auth.success.code_sent_email_registered': '¡Código enviado! Revise el email registrado (y la carpeta de spam).',
    'auth.success.code_sent_enter_email': '¡Código enviado! Ingrese el código de verificación enviado a su email.',
    'auth.dev.badge_title': 'Panel Interno DelivAI',
    'auth.dev.badge_subtitle': 'Acceso restringido a desarrolladores y operadores DelivAI.',
    'auth.tab.login': 'Entrar',
    'auth.tab.register': 'Sea cliente',
    'auth.step_1': 'Paso 1 de 2',
    'auth.step_2': 'Paso 2 de 2',
    'auth.collaborator_mode': 'Colaborador de la tienda',
    'auth.enter_as_store': 'Entrar como tienda',
    'auth.choose_store': '¿En qué tienda va a trabajar?',
    'auth.choose_store_aria': 'Elija la tienda',
    'auth.label.cpf': 'CPF',
    'auth.label.cnpj': 'CNPJ',
    'auth.label.account_key': 'CNPJ, CPF o correo',
    'auth.label.document': 'CNPJ o CPF',
    'auth.placeholder.account_key': 'CNPJ, CPF o correo',
    'auth.placeholder.document': 'CNPJ o CPF',
    'auth.hint.account_key': 'CNPJ de la tienda, CPF de quien no tiene CNPJ, o el correo de la Dark Kitchen.',
    'auth.error.document': 'Indique un CNPJ o CPF válido. Si es correo, incluya @.',
    'auth.hint.dev_cpf': 'Use el CPF registrado en el panel interno DelivAI.',
    'auth.validating': 'Validando...',
    'auth.continue': 'Continuar',
    'auth.back_store_login': 'Volver al login de la tienda',
    'auth.dev_role_label': 'Desarrollador DelivAI',
    'auth.change_cpf': 'Cambiar CPF',
    'auth.change_cnpj': 'Cambiar CNPJ',
    'auth.change_email': 'Cambiar correo',
    'auth.kitchen_group': 'Tiendas del grupo',
    'auth.label.kitchen_email': 'Correo',
    'auth.placeholder.kitchen_email': 'cocina@tienda.com',
    'auth.hint.kitchen_email': 'Correo del registro de la tienda que pasó a Dark Kitchen. La contraseña es la de la tienda.',
    'auth.kitchen_pick': '¿Qué tienda abrir?',
    'auth.key_switch': 'Entrar con CNPJ o correo',
    'auth.error.kitchen_email': 'No encontramos una Dark Kitchen con ese correo.',
    'auth.store_logo_alt': 'Logo de la tienda',
    'auth.logo_with_name': 'Logo {name}',
    'auth.label.password': 'Contraseña',
    'auth.label.email': 'Email',
    'auth.loading_login': 'Entrando...',
    'auth.forgot_password': '¿Olvidó su contraseña?',
    'auth.register.title': 'Sea nuestro cliente',
    'auth.register.subtitle': 'Complete los datos para solicitar su registro',
    'auth.register.success_title': '¡Registro realizado con éxito!',
    'auth.register.company_name': 'Nombre de la empresa *',
    'auth.register.trade_name': 'Nombre comercial',
    'auth.register.email': 'Email *',
    'auth.register.email_placeholder': 'ejemplo@ejemplo.com',
    'auth.register.responsible': 'Responsable *',
    'auth.register.responsible_placeholder': 'Nombre del responsable',
    'auth.register.phone': 'Teléfono *',
    'auth.register.phone_placeholder': '11 9535-2343',
    'auth.register.niche': 'Nicho de la empresa *',
    'auth.register.select_niche': 'Seleccione el nicho',
    'auth.register.niche.digital': 'Digital',
    'auth.register.niche.clinic': 'Clínica',
    'auth.register.niche.tattoo': 'Tatuaje',
    'auth.register.niche.delivery': 'Delivery',
    'auth.register.niche.workshop': 'Taller',
    'auth.register.sending': 'Enviando...',
    'auth.register.submit': 'Enviar registro',
    'auth.register.footer': 'Formulario automatizado con DelivAI',
    'auth.onboarding.intro': 'Informe el CNPJ o CPF, o envíe la foto o el PDF de la tarjeta CNPJ. Una lectura completa el registro.',
    'auth.onboarding.photo': 'Enviar foto o PDF de la tarjeta CNPJ',
    'auth.onboarding.drop': 'O suelte la foto o el PDF de la tarjeta aquí',
    'auth.onboarding.drop_now': 'Suelte la tarjeta aquí',
    'auth.onboarding.reading': 'Leyendo la tarjeta…',
    'auth.onboarding.reading_next': 'Después aparecen los datos para que los confirme.',
    'auth.onboarding.confirm': 'Confirmar',
    'auth.onboarding.correct': 'Corregir',
    'auth.onboarding.already_client': 'Este documento ya es cliente. Use Entrar.',
    'auth.onboarding.step_cnpj': 'Revise el documento',
    'auth.onboarding.step_name': 'Razón social y nombre comercial',
    'auth.onboarding.step_contact': 'Contacto de la empresa',
    'auth.onboarding.company_email': 'Email de la empresa',
    'auth.onboarding.company_phone': 'Teléfono de la empresa',
    'auth.onboarding.step_owner': 'Responsable',
    'auth.onboarding.owner_name': 'Nombre del responsable',
    'auth.onboarding.owner_cpf': 'CPF del responsable',
    'auth.onboarding.owner_hint': 'Esta persona entra como Admin Master de la tienda, con la contraseña creada al final.',
    'auth.onboarding.step_address': 'Dirección',
    'auth.onboarding.step_niche': 'Nicho',
    'auth.onboarding.step_about': 'La empresa',
    'auth.onboarding.step_pix': 'Clave PIX',
    'auth.onboarding.step_fees': 'Barrios y tasas',
    'auth.onboarding.step_terms': 'Contrato',
    'auth.onboarding.step_password': 'Contraseña de acceso',
    'auth.onboarding.trade': 'Nombre comercial',
    'auth.onboarding.legal_name': 'Razón social',
    'auth.onboarding.hours': 'Horario',
    'auth.onboarding.about': 'Sobre la empresa',
    'auth.onboarding.street': 'Calle',
    'auth.onboarding.number': 'Número',
    'auth.onboarding.neighborhood': 'Barrio',
    'auth.onboarding.city': 'Ciudad',
    'auth.onboarding.zip': 'CP',
    'auth.onboarding.state': 'UF',
    'auth.onboarding.pix': 'Clave PIX',
    'auth.onboarding.pix_type': 'Tipo de clave',
    'auth.onboarding.pix_type_placeholder': 'Seleccione el tipo',
    'auth.onboarding.pix_skip': 'Seguir sin PIX',
    'auth.onboarding.pix_later': 'Puede dejarlo en blanco y completarlo después, en el registro de la empresa.',
    'auth.onboarding.pix_cpf': 'CPF',
    'auth.onboarding.pix_cnpj': 'CNPJ',
    'auth.onboarding.pix_email': 'Correo',
    'auth.onboarding.pix_phone': 'Teléfono',
    'auth.onboarding.pix_random': 'Clave aleatoria',
    'auth.onboarding.fee_place': 'Barrio',
    'auth.onboarding.fee_value': 'Tasa',
    'auth.onboarding.fee_add': 'Agregar barrio',
    'auth.onboarding.fee_skip': 'Seguir sin tasa',
    'auth.onboarding.terms_doc': 'contrato de licencia',
    'auth.onboarding.terms_loading': 'Abriendo el contrato…',
    'auth.onboarding.terms_missing': 'No pude abrir el contrato. Intente de nuevo.',
    'company.menu_read.open': 'Leer foto',
    'company.menu_read.title_menu': 'Leer menú',
    'company.menu_read.title_service': 'Leer servicios',
    'company.menu_read.hint': 'Suelte la foto, elija el archivo o pegue con Ctrl+V. El + abre otra foto. Unificar junta todas.',
    'company.menu_read.tab': 'Foto {n}',
    'company.menu_read.tab_new': 'Nueva pestaña',
    'company.menu_read.tab_close': 'Cerrar pestaña',
    'company.menu_read.tab_close_title': '¿Cerrar esta foto?',
    'company.menu_read.tab_close_message': 'Los ítems de esta foto que aún no fueron al menú se descartarán.',
    'company.menu_read.panel_read': 'Lectura',
    'company.menu_read.panel_catalog': 'Menú',
    'company.menu_read.catalog_count': '{count} en el menú',
    'company.menu_read.dropped_count': '{count} en esta lectura',
    'company.menu_read.drop_here': 'Suelte aquí',
    'company.menu_read.select_hint': 'Seleccione uno o varios y arrastre a la categoría.',
    'company.menu_read.copy_registro': 'Copiar',
    'company.menu_read.copied': 'Copiado',
    'company.menu_read.copy_failed': 'No pude copiar el registro.',
    'company.menu_read.drag_handle': 'Arrastrar ítem',
    'company.menu_read.drag_count': '{count} ítems',
    'company.menu_read.select_item': 'Seleccionar ítem',
    'company.menu_read.collapse_item': 'Minimizar ítem',
    'company.menu_read.expand_item': 'Mostrar descripción y precios',
    'company.menu_read.tab_reading': 'Leyendo…',
    'company.menu_read.tab_error': 'Falló',
    'company.menu_read.no_items': 'Ningún ítem nuevo en esta foto.',
    'company.menu_read.empty_catalog': 'Arrastre los ítems a una categoría. Si falta, cree una nueva.',
    'company.menu_read.pending_other': 'La foto {n} todavía tiene una pregunta.',
    'company.menu_read.remove_dropped': 'Quitar de la categoría',
    'company.menu_read.destination': 'Categoría',
    'company.menu_read.new_category': 'O cree una categoría nueva',
    'company.menu_read.new_category_placeholder': 'Ej.: Sandwiches - Hot Dog',
    'company.menu_read.change_category': 'Cambiar categoría',
    'company.menu_read.pick_category_title': 'Elegir categoría',
    'company.menu_read.pick_category_hint': 'Toque una categoría ya guardada o cree una nueva para este ítem.',
    'company.menu_read.create_category': 'Usar',
    'company.menu_read.review_subtitle': 'Revise nombre, descripción, categoría y precios antes de guardar.',
    'company.menu_read.rename_title': 'Mismo producto, nombre distinto en el cadastro',
    'company.menu_read.rename_hint':
      'La foto trajo el nombre del menú impreso. En el cadastro aún aparece “base” u otra variación. ¿Actualizar el nombre guardado?',
    'company.menu_read.rename_from': 'Cadastro',
    'company.menu_read.rename_to': 'Foto',
    'company.menu_read.rename_yes': 'Usar nombre de la foto',
    'company.menu_read.rename_no': 'Mantener cadastro',
    'company.menu_read.add_price': 'Otro precio',
    'company.menu_read.price_name': 'Tipo de precio',
    'company.menu_read.price_new': 'Tipo de precio nuevo: {names}',
    'company.menu_read.price_same': '{from} entra como {to}.',
    'company.menu_read.as_addon': 'Adicional',
    'company.menu_read.as_product': 'Producto',
    'company.menu_read.as_pizza': 'Pizza',
    'company.menu_read.pick': 'Enviar foto',
    'company.menu_read.another': 'Enviar otra página',
    'company.menu_read.drop': 'Suelte la foto aquí',
    'company.menu_read.reading': 'Leyendo esta foto…',
    'company.menu_read.saving_menu': 'Actualizando el menú…',
    'company.menu_read.saving_service': 'Actualizando los servicios…',
    'company.menu_read.progress': 'Foto {current} de {total}',
    'company.menu_read.confirm': 'Confirmar',
    'company.menu_read.correct': 'Corregir',
    'company.menu_read.close': 'Cerrar',
    'company.menu_read.known': '{count} ya estaban guardados y no se repitieron.',
    'company.menu_read.section_known': 'Ya en el menú ({count})',
    'company.menu_read.known_empty': 'Ningún ítem de esta lectura ya estaba en el menú.',
    'company.menu_read.unify': 'Unificar',
    'company.menu_read.history': 'Historial',
    'company.menu_read.history_empty': 'Ninguna lectura guardada en este aparato.',
    'company.menu_read.history_past': 'Lectura ya hecha en esta tienda',
    'company.menu_read.history_pending': 'Pendiente',
    'company.menu_read.history_discarded': 'Descartada',
    'company.menu_read.history_updated': 'Actualizada en el menú',
    'company.menu_read.history_same_badge': 'Ya cubierta',
    'company.menu_read.history_same': 'Los mismos ítems están en {code}.',
    'company.menu_read.history_clash': 'Choca con {code}.',
    'company.menu_read.history_covered': 'Parte ya está en {code}.',
    'company.menu_read.history_clash_banner': 'Choca con {code}. Confirmar se queda con el precio de esta lectura y saca el ítem de la otra pendiente.',
    'company.menu_read.saved_codes': 'Menú actualizado. {code}.',
    'company.menu_read.saved_service_codes': 'Servicios actualizados. {code}.',
    'company.menu_read.history_no_prices': 'Esta lectura antigua no guardó los precios de la foto. Revisa los valores antes de confirmar, o descártala.',
    'company.menu_read.history_open': 'Abrir',
    'company.menu_read.history_reopen': 'Reabrir',
    'company.menu_read.history_discard': 'Descartar',
    'company.menu_read.history_discard_title': '¿Descartar esta lectura?',
    'company.menu_read.history_discard_message': 'Se queda en el historial como descartada. Se puede reabrir si quieres rehacerla.',
    'company.menu_read.already_same': 'Ya está en {category}. No creo otro.',
    'company.menu_read.aggregate': 'Agregar descripción',
    'company.menu_read.aggregate_keep': 'Dejar sin descripción',
    'company.menu_read.aggregate_hint': 'Mismo nombre. El cadastro no tiene descripción y la foto sí.',
    'company.menu_read.section_new': 'Van a entrar ({count})',
    'company.menu_read.lands_in': 'Entra en {category}',
    'company.menu_read.locked': 'En prueba',
    'company.menu_read.free': 'Liberado',
    'company.menu_read.cap_full': 'En la prueba puede dejar 10 productos liberados. Retenga uno para soltar otro.',
    'company.menu_read.failed': 'No pude leer esta foto. Pruebe otra.',
    'company.menu_read.limit': 'Se pueden enviar hasta 8 fotos.',
    'company.menu_read.too_big': 'Un archivo supera los 4 MB.',
    'company.menu_read.blocked': 'Ese tipo de archivo no se puede enviar.',
    'company.menu_read.description': 'Descripción',
    'company.menu_read.duration': 'Minutos',
    'company.menu_read.yes': 'Sí, en todos',
    'company.menu_read.no': 'No, solo en algunos',
    'company.menu_read.trial_line': '{open} liberados en esta lectura. {held} quedan guardados hasta la contratación.',
    'company.menu_read.trial_catalog': 'En la prueba, 10 productos quedan activos. El resto de esta lectura espera la contratación.',
    'company.menu_read.saved': 'Menú actualizado.',
    'company.catalog.search_clear': 'Limpiar búsqueda',
    'company.catalog.search_more': 'Mostrando 20 de {count}',
    'company.menu_read.registro': 'Registro {code}',
    'company.menu_read.registro_more': '{count} lecturas',
    'company.menu_read.discard': 'Descartar este ítem',
    'auth.onboarding.done_trial': 'Listo. Tiene 7 días de prueba. Entre con el documento y la contraseña. Para seguir después, la licencia está en el panel.',
    'auth.onboarding.done_saved': 'Listo. La contraseña fue creada. Entre con el documento y la contraseña.',
    'auth.onboarding.password_again': 'Repita la contraseña',
    'auth.onboarding.photo_failed': 'No pude leer la tarjeta. Pruebe otra foto o escriba el documento.',
    'auth.onboarding.password_mismatch': 'Las contraseñas no coinciden.',
    'auth.recovery.title': 'Recuperar contraseña',
    'auth.recovery.subtitle': 'Restablezca su contraseña en pocos pasos',
    'auth.recovery.store_cnpj': 'CNPJ de la tienda',
    'auth.recovery.back_login': 'Volver al login',
    'auth.recovery.how_receive': '¿Cómo desea recibir el código?',
    'auth.recovery.choose_channel_help': 'Elija el canal. La contraseña nueva vale en todas las tiendas de este CPF.',
    'auth.recovery.confirm_email': 'Confirmar email',
    'auth.recovery.email_code_help': 'Enviaremos un código de verificación al email registrado.',
    'auth.recovery.spam_hint': 'Revise también la carpeta de spam si no recibe el email.',
    'auth.recovery.sending': 'Enviando...',
    'auth.recovery.send_code': 'Enviar código',
    'auth.recovery.send_recovery': 'Enviar código de recuperación',
    'auth.recovery.sent_whatsapp': 'Código enviado por: WhatsApp',
    'auth.recovery.sent_to': 'Código enviado a: {destination}',
    'auth.recovery.verifying': 'Verificando...',
    'auth.recovery.verify_code': 'Verificar código',
    'auth.recovery.new_password': 'Nueva contraseña',
    'auth.recovery.confirm_password': 'Confirmar contraseña',
    'auth.recovery.confirm_new_password': 'Confirmar nueva contraseña',
    'auth.recovery.change_password': 'Cambiar contraseña',
    'auth.recovery.reset_password': 'Restablecer contraseña',
    'auth.recovery.changing': 'Cambiando...',
    'auth.recovery.your_email': 'su email',
    'auth.security': 'Seguridad',
    'auth.back': 'Volver',
    'auth.password_requirements': 'Requisitos de la contraseña:',
    'auth.password.min_length': 'Mínimo 6 caracteres',
    'auth.password.uppercase': 'Al menos una letra mayúscula',
    'auth.password.number': 'Al menos un número',
    'auth.password.special_char': 'Al menos un carácter especial (!@#$%^&*)',
    'auth.password.match': '✓ Las contraseñas coinciden',
    'auth.setup_link_first_access': 'Primer acceso - Configurar contraseña 🔑',
    'auth.collaborators': 'Colaboradores',
    'auth.dev_mode_button': 'Desarrolladores DelivAI',
    'auth.setup.first_access': 'Primer acceso',
    'auth.setup.subtitle_collab': 'Configure su contraseña para acceder al panel de la tienda',
    'auth.setup.subtitle_dev': 'Configure su contraseña para acceder al panel interno DelivAI',
    'auth.setup.subtitle_default': 'Configure su contraseña',
    'auth.setup.brand_logo_alt': 'Logo de DelivAI',
    'auth.setup.validating_invite': 'Validando invitación…',
    'auth.setup.invite_invalid_title': 'Enlace expirado o inválido',
    'auth.setup.invite_invalid_hint': 'Pida al responsable de la tienda una nueva invitación por WhatsApp.',
    'auth.setup.go_login': 'Ir al login',
    'auth.setup.enter_cpf': 'Ingrese su CPF',
    'auth.setup.enter_cnpj': 'Ingrese su CNPJ',
    'auth.setup.choose_channel': '¿Cómo desea recibir el código?',
    'auth.setup.confirm_email': 'Confirmar email',
    'auth.setup.channel_hint': 'Elija el canal para recibir el código de verificación',
    'auth.setup.channel.whatsapp': 'WhatsApp',
    'auth.setup.channel.email': 'Email',
    'auth.setup.email_masked': 'Email: {email}',
    'auth.setup.code_will_send': 'Enviaremos un código de 6 dígitos para confirmar su identidad.',
    'auth.setup.code_will_send_email': 'Enviaremos un código de verificación al email de arriba.',
    'auth.setup.spam_hint': 'Si elige email, revise también la carpeta de spam.',
    'auth.setup.spam_hint_email': '💡 Consejo: Revise también la carpeta de spam si no recibe el email.',
    'auth.setup.verification_code': 'Código de verificación',
    'auth.setup.create_password': 'Cree su contraseña',
    'auth.setup.create_password_btn': 'Crear contraseña',
    'auth.setup.confirm_password_label': 'Confirmar contraseña *',
    'auth.setup.checking_cpf': 'Verificando CPF…',
    'auth.setup.cpf_hint_invite': 'Ingrese su CPF para vincular a la invitación.',
    'auth.setup.cpf_hint_complete_signup': 'Ingrese su CPF para completar el registro y crear su contraseña.',
    'auth.setup.cpf_invalid_invite': 'CPF inválido o no coincide con la invitación.',
    'auth.setup.your_email': 'su email',
    'auth.setup.passwords_match': '✓ Las contraseñas coinciden',
    'auth.setup.creating_password': 'Creando...',
    'auth.setup.already_have_account': '¿Ya tiene una cuenta? Inicie sesión',
    'auth.setup.terms_of_use': 'términos de uso',
    'auth.setup.terms_accept_prefix': 'He leído y acepto los',
    'auth.setup.terms_version': '(versión {version}).',
    'auth.setup.terms_loading': 'Cargando {title}…',
    'auth.setup.terms_load_error': 'No fue posible cargar los términos.',
    'auth.setup.terms_modal_close': 'Cerrar',
    'auth.setup.progress.store': 'Tienda',
    'auth.setup.progress.cpf': 'CPF',
    'auth.setup.progress.send': 'Envío',
    'auth.setup.progress.code': 'Código',
    'auth.setup.progress.password': 'Contraseña',
    'auth.setup.progress.cnpj': 'CNPJ',
    'auth.setup.progress.email': 'Email',
    'auth.setup.step.confirm_email': 'Confirmar email',
  },
} as const;
